// Brand button — gold-gradient primary with sheen-sweep on hover.
// Variants: primary | secondary | ghost. Sizes: sm | md | lg.
import { forwardRef } from "react";

const BASE =
  "relative inline-flex items-center justify-center gap-2 font-sans font-medium uppercase tracking-[0.18em] " +
  "rounded-full transition-[transform,box-shadow,background-color,color] duration-300 " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold/60 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-bg " +
  "disabled:opacity-40 disabled:cursor-not-allowed select-none whitespace-nowrap";

const VARIANTS = {
  primary:
    "sheen text-brand-bg shadow-[0_18px_40px_-12px_rgba(201,168,76,0.45)] " +
    "hover:shadow-[0_20px_56px_-12px_rgba(201,168,76,0.65)] hover:-translate-y-[1px] active:translate-y-0",
  secondary:
    "bg-transparent text-brand-gold border border-brand-gold/40 hover:bg-brand-gold/10 hover:border-brand-gold/70",
  ghost:
    "bg-transparent text-brand-text/70 border border-brand-text/15 hover:text-brand-text hover:border-brand-text/40",
  // Sharp outline → fill on hover. No gradient, no sheen, no glow. Used for the
  // primary landing CTA ("REQUEST AN INVITATION") per brand direction.
  "outline-gold":
    "!rounded-[2px] !tracking-[0.15em] bg-transparent text-brand-gold border-[1.5px] border-brand-gold " +
    "hover:bg-brand-gold hover:text-brand-bg shadow-none transition-colors duration-300",
};

const SIZES = {
  sm: "h-9 px-4 text-[11px]",
  md: "h-11 px-6 text-xs",
  lg: "h-14 px-9 text-sm",
};

export const Button = forwardRef(function Button(
  { variant = "primary", size = "md", as = "button", className = "", style = {}, children, ...rest },
  ref
) {
  const Comp = as;
  const primaryStyle =
    variant === "primary"
      ? { backgroundImage: "linear-gradient(135deg, #E5C56A 0%, #C9A84C 50%, #A98C36 100%)", ...style }
      : style;
  return (
    <Comp
      ref={ref}
      className={`${BASE} ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${className}`}
      style={primaryStyle}
      {...rest}
    >
      {children}
    </Comp>
  );
});
